import { toChildArray, VNode } from "preact";
import { RoutesMap } from "./services/router";

type RouteProps = {
    'data-route'?: string
    'path'?: string;
};

export const parseRoutes = (element: VNode) => {
    const routesMap: RoutesMap = {};

    const childrenArray = toChildArray(element.props.children) as VNode<RouteProps>[];
    for (const child of childrenArray) {
        const name = child?.props?.['data-route'];
        const path = child?.props?.path;
        if (typeof name === 'string' && typeof path === 'string') {
            routesMap[name] = path;
        }
    }

    return routesMap;
};